import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// IMPORTANT: Do NOT mount React app for admin routes
// Admin panel is a separate Vite-built React app
if (window.location.pathname.startsWith('/admin')) {
  console.log("Admin route detected - skipping main React app mount");
} else {
  // Only render React app if root element exists (fallback for static site)
  const rootElement = document.getElementById("root");
  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  } else {
    // If no root element, we're probably on a static page
    console.log("No React root element found - static page loaded");
  }
}
